export const ProjectDonationStatus = {
  Pending: 0,
  Paid: 1,
  Cancelled: 2,
  AwaitingApproval: 3,
};

export const ProjectDonationStatusNames = {
  0: 'Beklemede',
  1: 'Ödendi',
  2: 'İptal Edildi',
  3: 'Onay Bekliyor',
};

export const ProjectPaymentMethodNames = {
  0: 'Nakit',
  1: 'Banka Havalesi/EFT',
  2: 'Kredi Kartı',
  3: 'Online Ödeme',
};

export const PaymentPersonType = {
  Member: 0,
  SubMember: 1,
};

export const getProjectDonationStatusChipSx = (status) => {
  switch (status) {
    case ProjectDonationStatus.Paid:
      return { backgroundColor: '#DFFFEA', color: '#17C653' };
    case ProjectDonationStatus.Cancelled:
      return { backgroundColor: '#F5F5F5', color: '#666666' };
    case ProjectDonationStatus.AwaitingApproval:
      return { backgroundColor: '#FFF4E6', color: '#FF9800' };
    default:
      return { backgroundColor: '#E7EDF4', color: '#0E4D94' };
  }
};
